<script setup>
import {getLogo} from "@/helpers/logo";
import {onMounted, ref} from "vue";
import {useRoute} from "vue2-helpers/vue-router";
import ecosystemNeedsService from "@/services/ecosystem/ecosystem-needs.service";
import EcosystemNeedAddStartup from "@/views/needs/ecosystem/EcosystemNeedAddStartup.vue";

const route = useRoute();
const needId = route.params.id;

const need = ref(null);
const search = ref('');
const hasStartups = ref(null);
const startups = ref([]);
const addStartup = ref(null);

onMounted(() => {
    getData();
})

async function getData() {
    await getInfo();
    await getStartups();
}

async function getInfo() {
    const {data} = await ecosystemNeedsService.getInfo(needId);
    need.value = data;
}

async function getStartups() {
    const {data} = await ecosystemNeedsService.getStartups(need.value.id, {search: search.value});

    startups.value = data;

    if (hasStartups.value === null && startups.value.length) {
        hasStartups.value = true;
    }
}

</script>

<template>
    <div v-if="need">
        <main class="page-startup">
            <section class="page-startup__content" >
                <header class="page-startup__header">
                    <div class="image-block-wrapper">
                        <div class="image-block image-block--md">
                            <img :src="getLogo(need.company_logo)" :alt="need.company_name">
                        </div>

                        <div>
                            <h2 class="page-startup__heading2">{{ need.name }}</h2>

                            <h3 class="page-startup__heading3">{{ need.company_name }}</h3>
                        </div>
                    </div>

                    <a
                        class="button button--link"
                        @click="addStartup.open()"
                    >
                        Submit Startup
                    </a>
                </header>

                <EcosystemNeedAddStartup
                    ref="addStartup"
                    :need-id="need.id"
                    @startupAdded="getData"
                />

                <div v-html="need.description"/>

                <div v-if="hasStartups" class="mt-4">
                    <form class="form-search form-search--inline">
                        <label for="fsi">My Submitted Startups</label>

                        <input id="fsi" placeholder="Search" v-debounce:500="getStartups" v-model="search" />
                    </form>

                    <table v-if="startups.length" class="details-table">
                        <thead>
                        <tr>
                            <th>Startup</th>
                            <th></th>
                        </tr>
                        </thead>

                        <tbody v-for="startup in startups" v-bind:key="startup.id">
                        <tr class="startup-row">
                            <td>
                                <div class="image-block-wrapper">
                                    <div class="image-block">
                                        <img :src="getLogo(startup.logoUrl)" :alt="startup.name">
                                    </div>

                                    <a :href="`/startups/${startup.id}`" target="_blank">
                                        <h5 class="heading5 m-0">{{ startup.name }}</h5>
                                    </a>
                                </div>
                            </td>
                            <td></td>
                        </tr>
                        </tbody>
                    </table>

                    <div v-else class="text-center">
                        No startups found
                    </div>
                </div>
            </section>
        </main>
    </div>
</template>

<style scoped>

</style>
